module.exports = __webpack_public_path__ + "img/project-suivi_manual_filled.1746f17b.png";